module.exports = __webpack_public_path__ + "static/media/main_image_2_pharmacore.f56714ee.jpg";